<template>
  <basic-select
    :options="options"
    :isError="isError"
    :reload="reload"
    :isDisabled="isDisabled"
    :selected-option="item"
    @select="onSelect"
    :placeholder="placeholder"
    robot="sel-catalogtype"
  >
  </basic-select>
</template>

<script>
import catalogtypeService from "@/helpers/service/catalogtype-service";
import { BasicSelect } from "vue-search-select";
import { StatusEnum } from "@/enum/status.enum.js";

export default {
  name: "CatalogTypeSelector",
  components: {
    "basic-select": BasicSelect,
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isDefault: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {
        return {
          text: null,
          value: null,
        };
      },
    },
    remove: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "กรุณาเลือก",
    },
  },
  mounted() {
    this.onGetCatalogTypeSelector();
  },
  data() {
    return {
      options: [],
      item: {
        value: null,
        text: null,
      },
    };
  },
  watch: {
    defaultValue: function(value, oldVal) {
      if (value.value && value.text) {
        this.item = value;
      }
    },
    reload: function(value) {
      if (value) {
        this.item = {
          value: null,
          text: null,
        };
      } else {
        this.onGetCatalogTypeSelector();
      }
    },
    remove: function(value) {
      if (value) {
        this.onGetCatalogTypeSelector();
      }
    },
    deep: true,
  },
  methods: {
    onSelect(item) {
      item.value =
        item.value === null || item.value === undefined ? "" : item.value;
      item.text =
        item.text === null || item.text === undefined ? "" : item.text;
      this.item = item;
      this.$emit("selected", { value: item.value, text: item.text });
    },
    async onGetCatalogTypeSelector() {
      this.options = [];

      let params = new URLSearchParams();
      params.append("pageSize", 999999);
      params.append("sort", "create_info.timestamp");
      params.append("status", StatusEnum.ACTIVE);
      let result = await catalogtypeService.getCatalogTypeMasterListAsync(
        params
      );
      if (result.status === 200) {
        result.data.items.forEach((element, index) => {
          this.options[index] = {
            value: element.id,
            text: element.display_name.en,
          };
        });
        if (this.remove) {
          this.options.forEach((element, index) => {
            if (element.value === this.remove) {
              this.options.splice(index, 1);
              console.log(index);
            }
          });
        }
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message);
        } else {
          console.log("Bad request: Unkonw error");
        }
      }
    },
  },
};
</script>
